/* WFF sticky Add to Cart bar. See sections/wff-sticky-atc.liquid. */
(function () {
  const bar = document.getElementById('WffStickyAtc');
  const dataEl = document.getElementById('WffStickyAtcData');
  if (!bar || !dataEl) return;

  // The buy box form (not quick-add modals or the related-products cards).
  const form =
    document.querySelector('.product__info-container form[data-type="add-to-cart-form"]') ||
    document.querySelector('product-form form[data-type="add-to-cart-form"]');
  const mainButton = form && form.querySelector('button[name="add"], .product-form__submit');
  if (!form || !mainButton) return;

  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const optionEl = bar.querySelector('[data-satc-option]');
  const priceEl = bar.querySelector('[data-satc-price]');
  const addBtn = bar.querySelector('[data-satc-add]');
  const changeLink = bar.querySelector('[data-satc-change]');
  const money = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);

  function selectedPlan() {
    // The Shopify Subscriptions widget writes a selling_plan input into (or next to) the form.
    const input =
      form.querySelector('input[name="selling_plan"]') ||
      document.querySelector('.product__info-container input[name="selling_plan"]:checked') ||
      document.querySelector('.product__info-container select[name="selling_plan"]');
    return input && input.value ? String(input.value) : '';
  }

  function update() {
    const idInput = form.querySelector('input[name="id"]');
    const v = idInput && data.variants[idInput.value];
    if (!v) return;
    const plan = selectedPlan();
    const parts = [];
    if (!data.single) parts.push(v.title);
    let planDetail = '';
    if (plan && data.planNames[plan]) {
      parts.push('Subscribe & Save');
      planDetail = data.planNames[plan].replace(/^Subscribe & Save\s*[,:-]?\s*/i, '');
    } else if (data.hasPlans) parts.push('One-time purchase');
    optionEl.textContent = parts.join(' · ');
    if (planDetail) {
      const span = document.createElement('span');
      span.className = 'wff-satc__plan';
      span.textContent = ', ' + planDetail.charAt(0).toLowerCase() + planDetail.slice(1);
      optionEl.appendChild(span);
    }
    const cents = plan && v.plans[plan] != null ? v.plans[plan] : v.price;
    priceEl.textContent = money(cents);
    const soldOut = !v.available || mainButton.disabled;
    // Sold out with a back-in-stock box showing (snippets/wff-back-in-stock.liquid): offer that instead.
    const notify = soldOut && notifyBox();
    addBtn.disabled = soldOut && !notify;
    addBtn.textContent = notify ? 'Notify me' : soldOut ? 'Sold out' : 'Add to cart';
  }

  function notifyBox() {
    const box = document.querySelector('[data-wff-bis][data-form-id="' + form.getAttribute('id') + '"]');
    return box && !box.hidden && !box.classList.contains('wff-bis--done') ? box : null;
  }

  // Show when the real button has scrolled up out of view; hide while a cart popup is open.
  let buttonAbove = false;
  function cartOpen() {
    return !!document.querySelector('.cart-notification.active, cart-drawer.active, cart-drawer[open]');
  }
  function render() {
    const show = buttonAbove && !cartOpen();
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('wff-satc-open', show);
    if (show) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
    else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
  }
  bar.hidden = false;
  // A scroll check (not an IntersectionObserver): a jump from below the fold to past the button,
  // e.g. an anchor link or restored scroll position, never crosses the viewport and fires no event.
  let ticking = false;
  function check() {
    ticking = false;
    // When the back-in-stock box replaces the buttons, the hidden button measures 0x0; track the box.
    const box = document.querySelector('[data-wff-bis][data-form-id="' + form.getAttribute('id') + '"]');
    const anchor = box && !box.hidden ? box : mainButton;
    const above = anchor.getBoundingClientRect().bottom < 0;
    if (above !== buttonAbove) { buttonAbove = above; render(); }
  }
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
  window.addEventListener('resize', check);
  check();

  addBtn.addEventListener('click', () => {
    update();
    const box = notifyBox();
    if (box) {
      box.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      const email = box.querySelector('input[type=email]');
      if (email) email.focus({ preventScroll: true });
      return;
    }
    mainButton.click();
  });
  changeLink.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.getElementById('wff-buy') || form.closest('.product__info-container') || form;
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    const focusable = target.matches('[tabindex]') ? target : form.querySelector('input, button, select');
    if (focusable) focusable.focus({ preventScroll: true });
  });

  // Keep in sync with the buy box: variant changes, subscription toggles, cart popups.
  ['change', 'click', 'input'].forEach((t) => document.addEventListener(t, () => setTimeout(() => { update(); render(); }, 60), true));
  new MutationObserver(() => { update(); render(); }).observe(form, { subtree: true, attributes: true, attributeFilter: ['value', 'disabled'], childList: true });
  document.addEventListener('wff:bis-change', () => { update(); check(); render(); });
  const notif = document.querySelector('.cart-notification, cart-drawer');
  if (notif) new MutationObserver(render).observe(notif, { attributes: true, attributeFilter: ['class', 'open'] });
  update();
})();
